var formatNumber = $.formatNumber = function(x){return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");}

$(function(){
    $('.cb-container').each(function(){
        var $parent = $(this);
        var $checkboxes = $parent.find('.cb-batch').not($parent.find('.cb-container .cb-batch'));

        var updateMain = function updateMain(){
            var $checkboxes = $parent.find('.cb-batch').not($parent.find('.cb-container .cb-batch'));
            var $groupCheckbox = $parent.find('.cb-batch-checker').not($parent.find('.cb-container .cb-batch-checker'));
            var $actions = $parent.find('.cb-batch-action').not($parent.find('.cb-container .cb-batch-action'));
            var checkednum = $checkboxes.filter(':checked').length
            var cbnum = $checkboxes.length;

            var faclass = 'circle';
            if(cbnum == 0 && checkednum == 0){
                faclass="fas fa-circle";
            }else if(cbnum == checkednum){
                faclass="fas fa-dot-circle"
            }else if(0 == checkednum){
                faclass="far fa-circle"
            }else{
                faclass="far fa-dot-circle";
            }
            $groupCheckbox.find('.cb-main i').attr('class',faclass);
            $actions.toggleClass('disabled',  checkednum === 0);

            $.each($parent.data('sums'),function(ind,sumKey){
                var sum = 0;
                $parent.find('tr').has('.cb-batch:checked').each(function(){sum+=$(this).data(sumKey);});
                $('#val-'+sumKey).text(formatNumber(sum));
            });

            $parent.trigger('xls-recalc');
        };

        var lastChecked = null;

        $checkboxes.click(function checkboxClick(e){
            var $checkboxes = $parent.find('.cb-batch').not($parent.find('.cb-container .cb-batch'));
            var $groupCheckbox = $parent.find('.cb-batch-checker').not($parent.find('.cb-container .cb-batch-checker'));
            var $actions = $parent.find('.cb-batch-action').not($parent.find('.cb-container .cb-batch-action'));
            if(!lastChecked) {lastChecked = this;return;}

            if(e.shiftKey) {
                var start = $checkboxes.index(this);
                var end = $checkboxes.index(lastChecked);
                $checkboxes.slice(Math.min(start,end), Math.max(start,end)+ 1).prop('checked', lastChecked.checked).trigger('futar:checked');
            }

            lastChecked = this;
        }).change(updateMain).on('futar:checked',updateMain);
        $parent.find('.paymode').on('change',function(){$parent.trigger('xls-recalc');})

        $parent.on('click','.cb',function groupSelect(){
            if(! $(this).parents('.cb-container').first().is($parent)) return;

            var $checkboxes = $parent.find('.cb-batch').not($parent.find('.cb-container .cb-batch'));
            var $groupCheckbox = $parent.find('.cb-batch-checker').not($parent.find('.cb-container .cb-batch-checker'));
            var $actions = $parent.find('.cb-batch-action').not($parent.find('.cb-container .cb-batch-action'));
            var cbnum = $checkboxes.length;

            switch($(this).data('type')){
                case '*':
                    $checkboxes.prop('checked', true).trigger('futar:checked');
                    break;
                case '-':
                    $checkboxes.prop( 'checked', false).trigger('futar:checked');
                    break;
                case '!':
                    $checkboxes.each(function(){$(this).prop( 'checked', ! $(this).prop( 'checked'));}).trigger('futar:checked');
                    break;
                case '.':
                    var checkednum = $checkboxes.filter(':checked').length
                    $checkboxes.prop('checked', checkednum < cbnum).trigger('futar:checked');
                    break;
            }
            updateMain();
        });

        updateMain();
    });

});
